module.exports = __webpack_public_path__ + "img/0xd4cb328a82bdf5f03eb737f37fa6b370aef3e888.a796abce.png";